import { BaseProps, AppearanceTypes } from 'components/Shared/Layout/base';
import { Block, Section } from 'components/Shared/Layout';
import styles from './styles.scss';
import cn from 'classnames';

type CheckoutBlockProps = BaseProps<AppearanceTypes>;

export const CheckoutBlock = ({ className, ...props }: CheckoutBlockProps) => (
  <Block {...props} className={cn(styles.checkoutBlock, className)} />
);

interface CheckoutHeadingProps {
  children: React.ReactNode;
  className?: string;
}

export const CheckoutHeading = ({ children, className }: CheckoutHeadingProps) => (
  <div className={cn(styles.checkoutHeading, className)}>{children}</div>
);

interface CheckoutSectionProps extends CheckoutBlockProps {
  disabled?: boolean;
}

export const CheckoutSectionWrapper = ({ shadow, disabled, ...props }: CheckoutSectionProps) => (
  <Block
    shadow={shadow}
    className={cn(styles.checkoutSectionWrapper, { [styles.disabled]: disabled })}
    {...props}
  />
);

export const CheckoutSection = ({
  padding: _padding,
  disabled,
  children,
  className,
  shadow: _shadow,
  ...props
}: CheckoutSectionProps) => {
  return (
    <Section
      className={cn(styles.checkoutSection, { [styles.disabled]: disabled }, className)}
      padding="none"
      {...props}
    >
      {children}
    </Section>
  );
};
